import React from 'react';
import Div from '~/components/atom/Div';
import AppEntryItemHeader from '~/components/page/Apps/components/AppEntryItemHeader';
import ImageOrAssetUploadComponent, {
  type Props as ImageOrAssetUploadComponentProps,
} from '~/components/molecule/ImageOrAssetUploadComponent';
import { Body } from '~/components/atom/Typography';

export type Props = ImageOrAssetUploadComponentProps & {
  title?: string;
  description?: string;
  required?: boolean;
  /** If passed, the component will render an ImageOrAssetUploadComponent component instead of an ImageUploadComponent */
  assetSelectionOpts?: {
    currentAssetId: string | null;
    initialAssetId: string | null;
    onChangeAssetId: ({ assetId }: { assetId: string }) => void;
  };
};

const ImageOrAssetInput: React.FCC<Props> = ({
  title,
  description,
  required = false,
  ...rest
}) => (
  <Div width="100%">
    {title && (
      <AppEntryItemHeader required={required}>{title}</AppEntryItemHeader>
    )}
    {description && <Body>{description}</Body>}

    <ImageOrAssetUploadComponent {...rest} />
  </Div>
);

export default ImageOrAssetInput;
